import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TenantConfiguration } from '../types/tenant-configuration.interface';

@Injectable({
  providedIn: 'root',
})

export class TenantService {
  private baseUri = environment.TENANT_BASE;
  private http = inject(HttpClient);
  constructor() {}

  getTenantConfigurationsByDomain(
    domain: string
  ): Observable<TenantConfiguration> {
    return this.http.get<TenantConfiguration>(
      `${this.baseUri}/configurations/${domain}`,
    );
  }
}
